import { ref } from "vue";

interface DroppedCompetency {
  competencyTitle: string;
  competencyGrouping: string;
  type?: string;
}

export const droppedCompetencies = ref<{ [key: string]: DroppedCompetency[] }>(
  {}
);

export const setDroppedCompetencies = (competencies: {
  [key: string]: DroppedCompetency[];
}) => {
  droppedCompetencies.value = competencies;
};

export const getDroppedCompetencies = () => {
  return droppedCompetencies.value;
};
